<div class="row">
    <div class="col-md-6 col-xl-8">
        <div class="row">
            <div class="col-md-6 col-xl-4">
                <div class="card card-custom card-stretch gutter-b">
                    <div class="card-body text-center">
                        <h5>
                            -
                        </h5>
                        <span class="font-weight-bold">Revolut Balance</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-xl-4">
                <div class="card card-custom card-stretch gutter-b">
                    <div class="card-body text-center">
                        <h5>
                            -
                        </h5>
                        <span class="font-weight-bold">Paypal Balance</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-xl-4">
                <div class="card card-custom card-stretch gutter-b">
                    <div class="card-body text-center">
                        <div><i *ngIf="(loadingStripePayouts$ | async)" class="icon-2x text-dark-50 ki ki-more-hor"></i></div>
                        <h5 *ngIf="!(loadingStripePayouts$ | async)">
                            {{(stripePayouts$ | async).length > 0 ? (stripePayouts$ | async)[0].toString() : 'None'}}
                        </h5>
                        <span class="font-weight-bold">Credit Card Payouts</span>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-xl-4">
                <div class="card card-custom card-stretch gutter-b">
                    <div class="card-body text-center">
                        <div><i *ngIf="(loadingTwilioAccountBalance$ | async)" class="icon-2x text-dark-50 ki ki-more-hor"></i></div>
                        <h5 *ngIf="!(loadingTwilioAccountBalance$ | async)">
                            {{twilioAccountBalance$ | async}}
                        </h5>
                        <span class="font-weight-bold">Twilio Balance</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-xl-4">
                <div class="card card-custom card-stretch gutter-b">
                    <div class="card-body text-center">
                        <div><i *ngIf="(loadingMessageBirdAccountBalance$ | async)" class="icon-2x text-dark-50 ki ki-more-hor"></i></div>
                        <h5 *ngIf="!(loadingMessageBirdAccountBalance$ | async)">
                            {{(messageBirdAccountBalance$ | async).amount}} EUR
                        </h5>
                        <span class="font-weight-bold">MessageBird Balance</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-xl-4">
                <div class="card card-custom card-stretch gutter-b">
                    <div class="card-body text-center">
                        <h5>
                            -
                        </h5>
                        <span class="font-weight-bold">Reserved</span>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="card card-custom gutter-b">
                    <div class="card-body">
                        <div class="my-card-title">
                        <span class="svg-icon svg-icon-primary svg-icon-2x mr-5">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24"/>
                                    <path d="M2,6 L21,6 C21.5522847,6 22,6.44771525 22,7 L22,17 C22,17.5522847 21.5522847,18 21,18 L2,18 C1.44771525,18 1,17.5522847 1,17 L1,7 C1,6.44771525 1.44771525,6 2,6 Z M11.5,16 C13.709139,16 15.5,14.209139 15.5,12 C15.5,9.790861 13.709139,8 11.5,8 C9.290861,8 7.5,9.790861 7.5,12 C7.5,14.209139 9.290861,16 11.5,16 Z" fill="#000000" opacity="0.3" transform="translate(11.500000, 12.000000) rotate(-345.000000) translate(-11.500000, -12.000000) "/>
                                    <path d="M2,6 L21,6 C21.5522847,6 22,6.44771525 22,7 L22,17 C22,17.5522847 21.5522847,18 21,18 L2,18 C1.44771525,18 1,17.5522847 1,17 L1,7 C1,6.44771525 1.44771525,6 2,6 Z M11.5,16 C13.709139,16 15.5,14.209139 15.5,12 C15.5,9.790861 13.709139,8 11.5,8 C9.290861,8 7.5,9.790861 7.5,12 C7.5,14.209139 9.290861,16 11.5,16 Z M11.5,14 C12.6045695,14 13.5,13.1045695 13.5,12 C13.5,10.8954305 12.6045695,10 11.5,10 C10.3954305,10 9.5,10.8954305 9.5,12 C9.5,13.1045695 10.3954305,14 11.5,14 Z" fill="#000000"/>
                                </g>
                            </svg>
                        </span>
                            <h5>Income Stats</h5>
                        </div>
                        <div class="row text-center">
                            <div class="col-4">
                                <h6>Today</h6>
                                <i *ngIf="(loadingWhmcsStats$ | async)" class="icon-2x text-dark-50 ki ki-more-hor"></i>
                                <span *ngIf="!(loadingWhmcsStats$ | async)" class="font-size-lg">
                                    {{(whmcsStats$ | async).incomeToday}}
                                </span>
                            </div>
                            <div class="col-4">
                                <h6>This month</h6>
                                <i *ngIf="(loadingWhmcsStats$ | async)" class="icon-2x text-dark-50 ki ki-more-hor"></i>
                                <span *ngIf="!(loadingWhmcsStats$ | async)" class="font-size-lg">
                                    {{(whmcsStats$ | async).incomeThisMonth}}
                                </span>
                            </div>
                            <div class="col-4">
                                <h6>This year</h6>
                                <i *ngIf="(loadingWhmcsStats$ | async)" class="icon-2x text-dark-50 ki ki-more-hor"></i>
                                <span *ngIf="!(loadingWhmcsStats$ | async)" class="font-size-lg">
                                    {{(whmcsStats$ | async).incomeThisYear}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row text-center">
            <div class="col-md-6 col-xl-4">
                <div class="card card-custom card-stretch gutter-b {{((whmcsStats$ | async).ordersPending > 0) ? 'bg-warning' : ''}}">
                    <div class="card-body">
                        <div><i *ngIf="(loadingWhmcsStats$ | async)" class="icon-2x text-dark-50 ki ki-more-hor"></i></div>
                        <h5 *ngIf="!(loadingWhmcsStats$ | async)">
                            {{(whmcsStats$ | async).ordersPending}}
                        </h5>
                        <span class="font-weight-bold">Orders Pending</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-xl-4">
                <div class="card card-custom card-stretch gutter-b {{((whmcsStats$ | async).ticketsOpen > 0) ? 'bg-warning' : ''}}">
                    <div class="card-body">
                        <div><i *ngIf="(loadingWhmcsStats$ | async)" class="icon-2x text-dark-50 ki ki-more-hor"></i></div>
                        <h5 *ngIf="!(loadingWhmcsStats$ | async)">
                            {{(whmcsStats$ | async).ticketsOpen}}
                        </h5>
                        <span class="font-weight-bold">
                            Tickets Open
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-xl-4">
                <div class="card card-custom card-stretch gutter-b {{((whmcsStats$ | async).cancellationsPending > 0) ? 'bg-danger text-white' : ''}}">
                    <div class="card-body">
                        <div><i *ngIf="(loadingWhmcsStats$ | async)" class="icon-2x text-dark-50 ki ki-more-hor"></i></div>
                        <h5 *ngIf="!(loadingWhmcsStats$ | async)">
                            {{(whmcsStats$ | async).cancellationsPending}}
                        </h5>
                        <span class="font-weight-bold">
                            Cancellations Pending
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-xl-4 d-xl-none">
                <div class="card card-custom card-stretch gutter-b">
                    <div class="card-body">
                        <div><i *ngIf="(loadingWhmcsStats$ | async)" class="icon-2x text-dark-50 ki ki-more-hor"></i></div>
                        <h5 *ngIf="!(loadingWhmcsStats$ | async)">
                            {{(whmcsStats$ | async).staffOnline}}
                        </h5>
                        <span class="font-weight-bold">
                            Staff Online
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-6">
                <div class="card card-custom gutter-b">
                    <div class="card-body">
                        <div class="my-card-title">
                        <span class="svg-icon svg-icon-primary svg-icon-2x mr-5">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                 <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24"/>
                                    <path d="M3.5,3 L5,3 L5,19.5 C5,20.3284271 4.32842712,21 3.5,21 L3.5,21 C2.67157288,21 2,20.3284271 2,19.5 L2,4.5 C2,3.67157288 2.67157288,3 3.5,3 Z" fill="#000000"/>
                                    <path d="M6.99987583,2.99995344 L19.754647,2.99999303 C20.3069317,2.99999474 20.7546456,3.44771138 20.7546439,3.99999613 C20.7546431,4.24703684 20.6631995,4.48533385 20.497938,4.66895776 L17.5,8 L20.4979317,11.3310353 C20.8673908,11.7415453 20.8341123,12.3738351 20.4236023,12.7432941 C20.2399776,12.9085564 20.0016794,13 19.7546376,13 L6.99987583,13 L6.99987583,2.99995344 Z" fill="#000000" opacity="0.3"/>
                                </g>
                            </svg>
                        </span>
                            <h5>Active Promotions</h5>
                        </div>
                        <div class="row text-center">
                            <div class="col-12">
                                <mat-progress-bar mode="indeterminate" *ngIf="(loadingWebsitePromotions$ | async)"></mat-progress-bar>
                                <div *ngIf="!(loadingWebsitePromotions$ | async) && !(hasWebsitePromotions$ | async)">No active promotions!</div>
                                <div *ngIf="!(loadingWebsitePromotions$ | async) && (hasWebsitePromotions$ | async)">
                                    <ng-container *ngFor="let websitePromotion of websitePromotions$ | async">
                                        <ng-container *ngIf="websitePromotion.linkedPromotion > 0" [ngTemplateOutlet]="WebsitePromotionTemplate" [ngTemplateOutletContext]="{item: websitePromotion}"></ng-container>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="col-md-6 col-xl-4">
        <div *ngIf="((whmcsStats$ | async).networkIssuesOpen > 0)" class="card card-custom bg-danger text-white gutter-b">
            <div class="card-body text-center">
                <div><i *ngIf="(loadingWhmcsStats$ | async)" class="icon-2x text-dark-50 ki ki-more-hor"></i></div>
                <h5 *ngIf="!(loadingWhmcsStats$ | async)">
                    {{(whmcsStats$ | async).networkIssuesOpen}}
                </h5>
                <span class="font-weight-bold">
                    Network Issues
                </span>
            </div>
        </div>
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <div class="my-card-title-with-tools">
                    <div class="title">
                        <span class="svg-icon svg-icon-primary svg-icon-2x mr-5">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24"/>
                                    <rect fill="#000000" opacity="0.3" x="2" y="3" width="20" height="18" rx="2"/>
                                    <path d="M9.9486833,13.3162278 C9.81256925,13.7245699 9.43043041,14 9,14 L5,14 C4.44771525,14 4,13.5522847 4,13 C4,12.4477153 4.44771525,12 5,12 L8.27924078,12 L10.0513167,6.68377223 C10.367686,5.73466443 11.7274983,5.78688777 11.9701425,6.75746437 L13.8145063,14.1349195 L14.6055728,12.5527864 C14.7749648,12.2140024 15.1212279,12 15.5,12 L19,12 C19.5522847,12 20,12.4477153 20,13 C20,13.5522847 19.5522847,14 19,14 L16.118034,14 L14.3944272,17.4472136 C13.9792313,18.2776054 12.7550291,18.143222 12.5298575,17.2425356 L10.8627389,10.5740611 L9.9486833,13.3162278 Z" fill="#000000" fill-rule="nonzero"/>
                                    <circle fill="#000000" opacity="0.3" cx="19" cy="6" r="1"/>
                                </g>
                            </svg>
                        </span>
                        <h5>Uptime Status</h5>
                    </div>
                    <div class="tools">
                        <button mat-icon-button color="primary" (click)="getServerUptimeStatus()">
                            <mat-icon aria-label="Edit">refresh</mat-icon>
                        </button>
                    </div>
                </div>
                <mat-progress-bar mode="indeterminate" *ngIf="(loadingMonitors$ | async)"></mat-progress-bar>
                <div *ngIf="!(loadingMonitors$ | async) && !(hasMonitors$ | async)">No servers found!</div>
                <div *ngIf="!(loadingMonitors$ | async) && (hasMonitors$ | async)">
                    <ng-container *ngFor="let website of monitors$ | async">
                        <ng-container [ngTemplateOutlet]="MonitorTemplate" [ngTemplateOutletContext]="{item: website}"></ng-container>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #MonitorTemplate let-item="item">
    <div class="row font-weight-bold">
        <div class="col-6 align-self-center text-left">
            <div>
                {{item.friendlyName}}
            </div>
        </div>
        <div class="col-6 text-right">
            <div>
                {{getServerUptimeStatusText(item.status)}}<span class="ml-2 label label-xl label-dot label-{{(item.status == monitorStatuses.UP) ? 'success' : ((item.status == monitorStatuses.DOWN) ? 'danger' : 'warning')}}"></span>
            </div>
            <div class="font-{{(item.status == monitorStatuses.UP) ? 'success' : ((item.status == monitorStatuses.DOWN) ? 'danger' : 'warning')}}">
                {{item.customUptimeRatio}}%
            </div>
        </div>
    </div>
    <hr/>
</ng-template>

<ng-template #WebsitePromotionTemplate let-item="item">
    <div class="row font-weight-bold text-center">
        <div class="col-5 align-self-center">
            {{item.name}}
        </div>
        <div class="col-2 align-self-center">
            <i class="icon-md text-dark-50 ki ki-long-arrow-next"></i>
        </div>
        <div class="col-5 align-self-center">
            {{item.linkedPromotionName}}
        </div>
    </div>
    <hr/>
</ng-template>